import { render } from "./CustomerIdentification.vue?vue&type=template&id=53aa2b4c"
import script from "./CustomerIdentification.vue?vue&type=script&lang=js"
export * from "./CustomerIdentification.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hostess.westfield.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__